import { all, call, put, takeLatest } from 'redux-saga/effects';
import { ShopClientInfo } from 'actions/actionTypes';
import * as actions from 'actions/shop/shopClientInfo';
import { callEditShopClientPassword } from 'network/apis/shop/shopClientInfo';

// 매장 클라이언트 비밀번호 수정 사가 함수
function* editShopClientPasswordRequestSaga(action) {
    try {
        // 액션에서 전달된 password 값을 사용
        const { shopGuid, newPassword } = action.payload;

        // axios 등을 사용할 때 JSON으로 보냄(Content-Type: application/json)
        const data ={
            newPassword, // 액션에서 받은 password (key와 value가 동일하면 하나로 줄일 수 있음)
        };

        const response = yield call(callEditShopClientPassword, shopGuid, data);

        // 응답 상태가 200일 경우 성공 처리
        if (response.status === 200) {
            yield put(actions.editShopClientPasswordRequestSuccess(response.data));
        } else {
            yield put(actions.editShopClientPasswordRequestFailure('Failed to change client information')); // 실패 액션 디스패치
        }

    } catch(error) {
        console.error('Error in Saga:', error);
        yield call(() => alert("Fail"));
        yield put(actions.editShopClientPasswordRequestFailure(error.message));
    }
}

export default function* root() {
    yield all([
        takeLatest(ShopClientInfo.EDIT_SHOP_CLIENT_PW_REQUEST, editShopClientPasswordRequestSaga),
    ]);
}